module.exports = __webpack_public_path__ + "img/agri-app.feee1fbc.jpg";